module.exports = __webpack_public_path__ + "mu.svg?01f12e8fd5517db2faf962e914b85d90";